module.exports = __webpack_public_path__ + "static/media/monkey-cropped.c5191fb0.png";